import { Unity, useUnityContext } from "react-unity-webgl";
import { Container } from "react-bootstrap";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import heartDecor from "../../../assets/images/coin-store-figma/decor-heart.svg";
import "./GameDetail.css";

export default function TicTacToe() {
    const navigate = useNavigate();
    const { unityProvider } = useUnityContext({
        loaderUrl: `${import.meta.env.VITE_REACT_APP_BASE_NAME}/UnityBuilds/TicTacToe/WebGlTicTacToe.loader.js`,
        dataUrl: `${import.meta.env.VITE_REACT_APP_BASE_NAME}/UnityBuilds/TicTacToe/WebGlTicTacToe.data`,
        frameworkUrl: `${import.meta.env.VITE_REACT_APP_BASE_NAME}/UnityBuilds/TicTacToe/WebGlTicTacToe.framework.js`,
        codeUrl: `${import.meta.env.VITE_REACT_APP_BASE_NAME}/UnityBuilds/TicTacToe/WebGlTicTacToe.wasm`,
    });

    return (
        <section className="game-detail-page">
            <img src={heartDecor} alt="" className="game-detail-heart" aria-hidden="true" />
            <div className="game-detail-hero">
                <Container className="game-detail-hero-inner">
                    <button className="game-detail-back-btn" onClick={() => navigate(-1)} aria-label="Go back">
                        <FaArrowLeftLong />
                    </button>
                    <h1 className="game-detail-title">Tic Tac Toe</h1>
                </Container>
            </div>
            <div className="game-detail-main py-sm-5 py-4">
                <Container className="game-detail-container">
                    <div className="game-detail-frame game-detail-frame-ttt">
                        <Unity unityProvider={unityProvider} className="game-detail-unity game-detail-unity-ttt" />
                    </div>
                </Container>
            </div>
        </section>
    );
}
